import React, { Component } from "react";
import { Header, Table, Segment } from "semantic-ui-react";
import { apiUrl } from "../../utils/constants";

class HelpXml extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h3">
          <Header.Subheader>
            Your winners XML feed is located here:
          </Header.Subheader>
          <a href={apiUrl() + "/feeds/winners"} target="_blank" rel="noopener noreferrer">
            {apiUrl() + "/feeds/winners"}
          </a>
        </Header>
        <p>
          This feed provides a list of all past winners which may be used on
          external websites.
        </p>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                Available XML Elements:
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>event_id</Table.Cell>
              <Table.Cell>The system assigned ID for this event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>number</Table.Cell>
              <Table.Cell>The winning number.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>jackpot</Table.Cell>
              <Table.Cell>
                  The jackpot amount. Note that this is only available for Split the Pot raffles.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>amount</Table.Cell>
              <Table.Cell>
                The prize amount. Note that this is half of the jackpot total.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>claimed</Table.Cell>
              <Table.Cell>
                0 if the prize has not been marked as claimed, 1 if it has been
                marked as claimed.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>time_picked</Table.Cell>
              <Table.Cell>A timestamp of when the winning number was picked.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>eventtitle</Table.Cell>
              <Table.Cell>The title of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>date</Table.Cell>
              <Table.Cell>The date of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>draw_type</Table.Cell>
              <Table.Cell>The type of the event (Merchandise / Split The Pot / Chase The Ace).</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>round_prize</Table.Cell>
              <Table.Cell>Normalized jackpot prize.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>suit</Table.Cell>
              <Table.Cell>The suit of the revealed card for CTA events.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>rank</Table.Cell>
              <Table.Cell>The rank of the revealed card for CTA events</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>envelope</Table.Cell>
              <Table.Cell>The envelope opened for CTA events.</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default HelpXml;
